import { dispatchProps } from '@/entity';
import { setLocalStorage, setSessonStorage } from '@/utils';
import { TLang } from '@/utils/lang';

export default {
  namespace: 'initData', // 表示在全局 state 上的 key
  state: {
    currentAddress: null,
    showAddrPage:false,
    menus: {
      shoppingH5HomeIndex: '/tmall/home',
      h5UserCenter: '/tmall/user',
      h5ShoppingCart: '/tmall/shopping/cart',
      classifyUrl: '/tmall/classification',
      h5HomeIndex: '/mall',
      bookH5HomeIndex: '/book',
      newUnion: 0,
      menuItems: [],
      showMenu: false
    },
    /** 百福德相关数据 */
    unionConfig: {
      union_scale: 1,
      union_icon: '',
      union_name:  TLang('福豆', 'card')
    }
  }, // 状态数据
  // 管理同步方法，必须是纯函数
  reducers: {
    // 百福德相关数据
    setUnionConfig(state, { type, payload }: dispatchProps) {
      const obj = Object.assign(state.unionConfig, payload);
      console.log('setUnionConfig', obj);
      // const newObj = JSON.stringify({...state,
      //   unionConfig: obj
      // });
      // return JSON.parse(newObj);
      return {
        ...state,
        unionConfig: JSON.parse(JSON.stringify(obj))
      };
    },
    setMenus(state, { type, payload }: dispatchProps) {
      const obj = Object.assign(state.menus, payload);
      return {
        ...state,
        menus: obj
      };
    },
    setShowMenu(state, { type, payload }: dispatchProps) {

      return {
        ...state,
        showMenu: payload
      };
    },
    setShowAddrPage(state, { type, payload }: dispatchProps) {

      return {
        ...state,
        showAddrPage: payload
      };
    },
    setAddress(state, { type, payload }: dispatchProps) {
      setSessonStorage('currentAddress', JSON.stringify(payload));
      return {
        ...state,
        currentAddress: payload
      };
    },
    setLoginStatus(state, {type, payload}:dispatchProps){
      setSessonStorage('loginInfo', JSON.stringify(payload));
      return {
        ...state,
        loginInfo: payload
      };
    }
  },
  effects: {
  },
  subscriptions: {} // 订阅数据源
};
